<template>
  <div class="parent">
    <div class="divTitle">
      <div class="divTitleDisplay">
        <img src="../../img/baseStart.png" /><span class="titleSpan">{{ title }}</span
        ><slot></slot><img src="../../img/baseEnd.png" />
      </div>
      <div class="divDescribe" v-if="desc">{{ desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    bgFont: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/commonTitleWidge";
</style>
